import React from 'react';
import ExcelIcon from '../../assets/svg/metaEdit/excel_meta.svg';

const ExportButton = ({ onClick }) => (
  <button onClick={onClick} className="meta-excel">
    <img src={ExcelIcon} style={{ width: 20, marginRight: 15 }} alt="Export" /> Export
  </button>
);

export default ExportButton;